const theme = localStorage.getItem('recruitee-theme') || 'light';
document.documentElement.setAttribute('data-theme', theme);
